import {createAction} from 'redux-actions';
import {REFRESH_KIOSK_TOKEN} from '../config/const';

const SET_KIOSK_CUSTOMER = 'SET_KIOSK_CUSTOMER';

/* ******* */
/* ACTIONS */
/* ******* */

export const setKioskCustomer = createAction(
  SET_KIOSK_CUSTOMER, tokens => tokens
);

/* ****** */
/* STATE  */
/* ****** */

const initialState = {
  firstName: 'John',
  lastName: 'Apple',
  phone: '',
  rewardPoints: '',
  redemeedPoints: '',
  rewardTier: '',
  id: null,
  isRec: false,
  isID: false,
  tempUser: {},
  tokens: {
    refreshTokenPending: false
  },
  isKioskCustomer: false
};


const kioskUserReducer = (state = initialState, action) => {
  switch (action.type) {
  case SET_KIOSK_CUSTOMER: {
    return {
      ...initialState,
      tokens: action.payload,
      isKioskCustomer: true
    };
  }
  case REFRESH_KIOSK_TOKEN: {
    return {
      ...state,
      tokens: {
        ...state.tokens,
        ...action.payload
      }
    };
  }
  default: {
    return state;
  }
  }
};

export default kioskUserReducer;



// WEBPACK FOOTER //
// ./src/reducers/kioskUserReducer.js